import axios from '@axios'

const PREFIX = 'caixas-postais'

export default {

  getPaginado(page, pageSize, filtros) {
    return axios.post(`${PREFIX}/paged?pagina=${page}&tamanhoPagina=${pageSize}`, filtros)
  },

  getCaixaPostal(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  getMensagemNaoLida(id) {
    return axios.get(`${PREFIX}/${id}/mensagem`)
  },

  atualizarMensagemLida(id) {
    return axios.get(`${PREFIX}/${id}/mensagemLida`)
  },

  getMensagemPaginado(empresaId, page, pageSize, filtros) {
    return axios.post(`${PREFIX}/empresas/${empresaId}/mensagens?pagina=${page}&tamanhoPagina=${pageSize}`, filtros)
  },

  notificaMensagem(nomeEmpresa, emailEmpresa, emailCc, id, mensagemAdicional, definirEmailPadrao) {
    return axios.post(`${PREFIX}/${id}/notifica?emailEmpresa=${emailEmpresa}&emailCc=${emailCc}&nomeEmpresa=${nomeEmpresa}&mensagemAdicional=${encodeURIComponent(mensagemAdicional)}&definirEmailPadrao=${definirEmailPadrao}`)
  },

  getObservacoes(id) {
    return axios.get(`${PREFIX}/${id}/observacao`)
  },

  removerObservacao(id) {
    return axios.delete(`${PREFIX}/observacao/${id}/remover`)
  },

  salvarObservacao(observacao) {
    return axios.post(`${PREFIX}/observacao/salvar`, observacao)
  },

  baixarEmExcel(tipo, filtros) {
    return axios.post(`${PREFIX}/baixa-excel`, filtros)
  },

  deletarExcel(url, nomeArquivo) {
    return axios.post(`${PREFIX}/deletar-excel?url=${encodeURIComponent(url)}&nomeArquivo=${encodeURIComponent(nomeArquivo)}`)
  },

  baixarEmExcelMensagens(empresaId, razaoSocial, cnpj, filtros) {
    return axios.post(`${PREFIX}/empresas/${empresaId}/mensagens/baixa-excel?razaoSocial=${encodeURIComponent(razaoSocial)}&cnpj=${encodeURIComponent(cnpj)}`, filtros)
  },

  deletarExcelMensagens(url, nomeArquivo) {
    return axios.post(`${PREFIX}/mensagens/deletar-excel?url=${encodeURIComponent(url)}&nomeArquivo=${encodeURIComponent(nomeArquivo)}`)
  },
}
